// src/components/DataTable/DataTable.js

import React from 'react';
import './DataTable.css';
// --- Import icons ---
import { FiEdit, FiTrash2, FiEye } from 'react-icons/fi'; // Using Feather Icons

const DataTable = ({
  data,
  columns,
  onEdit,
  onDelete,
  editButtonLabel = 'Edit', // A customizable label for the edit/view button
  actionButtonClasses = {} // An object for custom CSS classes
}) => {

  /**
   * THE FIX IS HERE: A new, more robust getColumnValue function.
   * This function can handle three types of accessors:
   *  1. A simple string (e.g., 'email')
   *  2. A nested string for related data (e.g., 'user.name')
   *  3. A function that returns a custom value (e.g., for combining names)
   */
  const getColumnValue = (item, accessor) => {
    // 1. Check if the accessor is a function
    if (typeof accessor === 'function') {
      // If so, execute the function, passing the entire item
      return accessor(item);
    }

    // 2. If the accessor is a string, handle simple and nested cases
    if (typeof accessor === 'string') {
      // The .split() and .reduce() combo safely navigates nested objects
      return accessor.split('.').reduce((obj, key) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined), item);
    }
    
    // Return a fallback if the accessor is invalid
    return 'N/A';
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    // Check if the date is valid before formatting
    return !isNaN(date.getTime()) ? date.toLocaleString() : 'Invalid Date';
  };

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.header}>{col.header}</th>
            ))}
            {/* Only show the Actions header if there are actions */}
            {(onEdit || onDelete) && <th className="actions-header">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((item) => (
              <tr key={item._id}>
                {columns.map((col) => {
                  // Get the raw value using our new robust function
                  const cellValue = getColumnValue(item, col.accessor);
                  
                  return (
                    <td key={col.header} data-label={col.header}>
                      {/* Format the value if it's a date, otherwise display it.
                          Also provide a fallback for null or undefined values. */}
                      {col.isDate ? formatDate(cellValue) : (cellValue ?? 'N/A')}
                    </td>
                  );
                })}
                
                {/* Actions Column */}
                {(onEdit || onDelete) && (
                  <td data-label="Actions">
                    <div className={actionButtonClasses.wrapper || 'action-buttons'}>
                      {onEdit && (
                        <button onClick={() => onEdit(item)} className={actionButtonClasses.edit || 'action-btn edit-btn'}>
                          {/* Show a "View" icon if the button label is 'View' */}
                          {editButtonLabel.toLowerCase() === 'view' ? <FiEye /> : <FiEdit />}
                          <span>{editButtonLabel}</span>
                        </button>
                      )}
                      {onDelete && (
                        <button onClick={() => onDelete(item._id)} className={actionButtonClasses.delete || 'action-btn delete-btn'}>
                          <FiTrash2 />
                          <span>Delete</span>
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length + 1} className="no-data-cell">
                No data to display.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;